var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[(_vm.hasPlans)?_c('v-flex',{staticClass:"my-3",attrs:{"xs12":""}},[_c('app-membership-offer',{on:{"select":function($event){return _vm.submitplan(("" + ($event.id)))}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5baf680a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-buttons/app-btn-toggle-plan-reg-sub.vue
// module id = null
// module chunks = 